import * as Html from "../../util/Html.ts";
Html.registerWidget('widget/form/displaycontrolledbyinput',{init:init})

function init(obj){
  var 
    inputName = obj.attr('data-input'),
    input = $(obj.parent('form').get(0)[inputName]);
  
  function onChange(){
    obj.toggle(this.value==='true')
  }
  input.on('change',onChange)  
  
  onChange.apply(input.get(0))
}